import { mapValues } from "@faire/web--source/common/mapValues";
export var cartHasValidBrandDiscounts = function(brandDiscounts) {
    var now = Date.now();
    var discounts = mapValues(brandDiscounts).filter(function(d) {
        return d.active;
    });
    return discounts.some(function(discount) {
        var _discount_retailer_amount;
        var _discount_retailer_amount_amount_cents;
        if ((_discount_retailer_amount_amount_cents = (_discount_retailer_amount = discount.retailer_amount) === null || _discount_retailer_amount === void 0 ? void 0 : _discount_retailer_amount.amount_cents) !== null && _discount_retailer_amount_amount_cents !== void 0 ? _discount_retailer_amount_amount_cents : 0 > 0) {
            return true;
        } else if (discount.free_shipping && discount.free_shipping_until && discount.free_shipping_until > now) {
            return true;
        }
        return false;
    });
};
